import { ColorRing } from "react-loader-spinner";
import "./index.css";

function LoadingSpinner({ ariaLabel = "loading" }) {
  return (
    <div className="loading-state">
      <ColorRing
        visible={true}
        height="80"
        width="80"
        ariaLabel={ariaLabel}
        colors={["#e15b64", "#808080", "#f0f0f0", "#808080", "#e15b64"]}
      />
    </div>
  );
}

export default LoadingSpinner;
